import { render, staticRenderFns } from "./OkycItem.vue?vue&type=template&id=23de4f2e&scoped=true&"
import script from "./OkycItem.vue?vue&type=script&lang=js&"
export * from "./OkycItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=23de4f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de4f2e",
  null
  
)

export default component.exports